import { Component, OnInit } from '@angular/core';
import { random } from 'lodash';
import { VeterinariaService } from 'src/core/veterinaria/veterianaria.service';
import { Veterinaria } from 'src/core/veterinaria/veterinaria.types';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit{

  
  veterinarias: Veterinaria[] = [];

  constructor(
    private _veterinariaService: VeterinariaService,
  ){

  }
  ngOnInit(): void {
    this.getVeterinarias();
  }

  getVeterinarias(){
    this._veterinariaService.veterinarias$.subscribe({
      next: (vets: Veterinaria[]) => {
        this.veterinarias = vets;
      },
      error: (error: any) => {
        console.log('err : ', error);
      }
    });
  }

}
